import { CircleInfoIcon } from "@xola/icons";
import { Input, Label, Select, Tooltip } from "@xola/ui-kit";
import { FormField } from "common";
import { useFormikContext } from "formik";
import React from "react";
import { DownDeposit, PaymentMethod } from "types";
import { SuffixField } from "../../Field/SuffixField";
import { BasicDiscountAddonTerm, BasicDiscountTerm } from "./PricingSelectorHelper";

export interface PackagePricingValues {
    paymentMethod: PaymentMethod;
    downDeposit?: DownDeposit;
    basicDiscount: BasicDiscountTerm;
}

export const BasicTerm = () => {
    const { values, setFieldValue } = useFormikContext<PackagePricingValues>();

    const handleChange = (e: any) => {
        setFieldValue("basicDiscount.includeAddons", e.target.value);
    };

    return (
        <>
            <div className="mt-4 w-40 pb-1">
                <FormField name="basicDiscount.discount" label="Applied Discount">
                    <SuffixField suffix="%">
                        <Input
                            isRequired
                            allowZero
                            type="number"
                            min={0}
                            placeholder="Discount"
                            value={values.basicDiscount.discount}
                            onChange={(e: any) =>
                                setFieldValue(
                                    `basicDiscount.discount`,
                                    e.target.value ? Math.abs(Number(e.target.value)) : undefined,
                                )
                            }
                        />
                    </SuffixField>
                </FormField>
            </div>
            <Label>
                <span className="mr-1">Add-ons</span>
                <Tooltip placement="auto" content="Choose if the discount applies to add-ons or not">
                    <CircleInfoIcon />
                </Tooltip>
            </Label>
            <Select className="w-full rounded-none" value={values.basicDiscount.includeAddons} onChange={handleChange}>
                <option value={BasicDiscountAddonTerm.INCLUDING_ADD_ONS}>Including Add-ons</option>
                <option value={BasicDiscountAddonTerm.EXCLUDING_ADD_ONS}>Excluding Add-ons</option>
            </Select>
        </>
    );
};
